import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';
import { Workflow } from 'lucide-react';
import { API } from '../../App';

const yes = (v) => (v ? 'Yes' : 'No');

const rows = (d, label) => [
  { k: 'Registered / charges ' + label, v: `${yes(d.is_vat_registered)} / ${yes(d.charges_vat)}`, where: 'Invoice lines, bank-feed receipts, Review suggestions' },
  { k: 'Default sales treatment', v: d.default_sales_treatment || '—', where: 'Fallback when a line has no catalogue item' },
  { k: `Input ${label} recoverable`, v: yes(d.input_vat_recoverable), where: 'Bill lines, bank-feed payments, Review suggestions' },
  { k: 'Sells abroad (exports)', v: yes(d.sells_exports), where: 'Zero-rates lines to overseas customers only; otherwise flags them for review' },
  { k: 'Reverse charge on imported services', v: yes(d.reverse_charge_imported_services), where: 'Bills from non-resident suppliers' },
  { k: 'Price display default', v: d.price_display_varies ? 'Varies (choose per document)' : (d.price_display || 'exclusive'), where: 'Starting VAT mode on new invoices and bills' },
  { k: 'WHT agent (deducts from suppliers)', v: yes(d.is_wht_agent), where: 'WHT payable on bills and bank-feed payments (pack exemptions applied per payment)' },
  { k: 'Customers deduct WHT', v: yes(d.wht_credit_expected), where: 'WHT receivable expectation on invoices to corporate customers' },
  { k: 'Development Levy', v: d.development_levy_applies === undefined ? '—' : yes(d.development_levy_applies), where: 'Corporate tax computation (derived from turnover band)' },
];

export const TaxSetupUsageCard = () => {
  const [view, setView] = useState(null);
  useEffect(() => { axios.get(`${API}/tax-setup`).then((r) => setView(r.data)).catch(() => {}); }, []);
  const d = view?.derived;
  if (!view?.schema || !d || !view?.status?.complete) return null;
  const label = view.schema.tax_label || 'VAT';
  const list = rows(d, label).filter((r) => view.schema.has_wht || !r.k.includes('WHT'));
  return (
    <Card data-testid="tax-setup-usage-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Workflow className="w-5 h-5 text-[#283F8B]" /> How your tax setup is used</CardTitle>
        <CardDescription>One decision engine reads these facts for every invoice line, bill line, bank-feed auto-post and Review suggestion. Change an answer in the questionnaire and every pathway follows.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="divide-y divide-slate-100 text-sm">
          {list.map((r) => (
            <div key={r.k} className="grid sm:grid-cols-[1fr_auto_1.4fr] gap-x-4 gap-y-0.5 py-2" data-testid={`tax-usage-${r.k.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
              <span className="text-slate-700">{r.k}</span>
              <Badge variant="outline" className="justify-self-start capitalize">{r.v}</Badge>
              <span className="text-xs text-slate-500">{r.where}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
